import type { ReactNode } from 'react';
import styles from './ChartCard.module.css';

interface ChartCardProps {
  title: ReactNode;
  subtitle?: string;
  children: ReactNode;
  height?: number | 'auto';
  action?: ReactNode;
}

export function ChartCard({ title, subtitle, children, height = 300, action }: ChartCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div>
          <div className={styles.title}>{title}</div>
          {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        </div>
        {action}
      </div>
      <div className={styles.body} style={{ height }}>
        {children}
      </div>
    </div>
  );
}
